import { render, staticRenderFns } from "./formSelect.vue?vue&type=template&id=63f75ec4&scoped=true"
import script from "./formSelect.vue?vue&type=script&lang=js"
export * from "./formSelect.vue?vue&type=script&lang=js"
import style0 from "./formSelect.vue?vue&type=style&index=0&id=63f75ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f75ec4",
  null
  
)

export default component.exports